var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "royale-page" }, [
    _c("section", { staticClass: "warzone-hero" }, [
      _vm._m(0),
      _c(
        "button",
        {
          staticClass: "deploy-button",
          attrs: { type: "button", disabled: _vm.busy },
          on: { click: _vm.createRoom },
        },
        [
          _c("span", [_vm._v("建立战区")]),
          _c("small", [_vm._v("召集对手或部署 AI")]),
        ]
      ),
    ]),
    _c("section", { staticClass: "lobby-band" }, [
      _c("header", { staticClass: "lobby-heading" }, [
        _vm._m(1),
        _c("div", { staticClass: "lobby-stats" }, [
          _c("div", [
            _c("span", [_vm._v("开放战局")]),
            _c("strong", [_vm._v(_vm._s(_vm.waitingRoomCount))]),
          ]),
          _c("div", [
            _c("span", [_vm._v("正在交火")]),
            _c("strong", [_vm._v(_vm._s(_vm.activeRoomCount))]),
          ]),
          _c("div", [
            _c("span", [_vm._v("最高奖池")]),
            _c("strong", [_vm._v(_vm._s(_vm.formatCoin(_vm.highestPot)))]),
          ]),
        ]),
      ]),
      _vm.rooms.length
        ? _c(
            "div",
            { staticClass: "room-list" },
            _vm._l(_vm.rooms, function (room) {
              return _c(
                "button",
                {
                  key: room.roomId,
                  class: ["room-row", "state-" + room.state.toLowerCase()],
                  attrs: { type: "button", disabled: _vm.busy },
                  on: {
                    click: function ($event) {
                      return _vm.openRoom(room.roomId)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "status-light" }),
                  _c("span", { staticClass: "room-code" }, [
                    _c("small", [_vm._v("战区编号")]),
                    _c("strong", [_vm._v("#" + _vm._s(room.roomId))]),
                  ]),
                  _c("span", { staticClass: "room-data" }, [
                    _c("small", [_vm._v("参战者")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(room.players.length) +
                          "/" +
                          _vm._s(room.maxPlayerCount || 6)
                      ),
                    ]),
                  ]),
                  _c("span", { staticClass: "room-data" }, [
                    _c("small", [_vm._v("当前战况")]),
                    _c("strong", [_vm._v(_vm._s(_vm.roomStatus(room)))]),
                  ]),
                  _c("span", { staticClass: "room-data pot" }, [
                    _c("small", [_vm._v("争夺奖池")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.formatCoin(
                            room.potAmount || room.players.length * 10
                          )
                        ) + " Coin1"
                      ),
                    ]),
                  ]),
                  _c("span", { staticClass: "room-action" }, [
                    _vm._v(
                      _vm._s(
                        room.state === "Waiting" ? "加入战局" : "查看战况"
                      ) + " "
                    ),
                    _c("b", [_vm._v("›")]),
                  ]),
                ]
              )
            }),
            0
          )
        : !_vm.busy
        ? _c("div", { staticClass: "empty" }, [
            _c("strong", [_vm._v("战场暂时沉寂")]),
            _c("span", [_vm._v("建立一个新战区，等待第一批参战者。")]),
          ])
        : _vm._e(),
    ]),
    _vm.errorMessage
      ? _c("p", { staticClass: "error-message" }, [
          _vm._v(_vm._s(_vm.errorMessage)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero-content" }, [
      _c("span", { staticClass: "eyebrow" }, [_vm._v("LAST SURVIVOR")]),
      _c("h1", [_vm._v("大逃杀")]),
      _c("p", [_vm._v("进入生存舱，避开每轮爆炸。活到最后，带走整座奖池。")]),
      _c("div", { staticClass: "hero-rules" }, [
        _c("span", [_vm._v("入场筹码 "), _c("strong", [_vm._v("10 Coin1")])]),
        _c("span", [_vm._v("参战规模 "), _c("strong", [_vm._v("2-6 人")])]),
        _c("span", [_vm._v("决策时间 "), _c("strong", [_vm._v("15 秒")])]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "section-kicker" }, [
        _vm._v("LIVE OPERATIONS"),
      ]),
      _c("h2", [_vm._v("实时战区")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }